import { Component, Renderer2, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AppSettingsService } from '../../shared/app-settings/app-settings.service';

@Component({
	selector: 'app-freshdesk-chat',
	templateUrl: './freshdesk-chat.component.html'
})
export class FreshdeskChatComponent implements OnInit {

	public user: any = this.appSettings.data.user;
	public isActive: boolean = this.user.registration_language === 'pl';

	constructor(
		private _renderer2: Renderer2,
		@Inject(DOCUMENT) private _document,
		private appSettings: AppSettingsService
	) { }

	init() {
		if ( !this.isActive ) { return; }

		try {
			const that: any = this;
			const s: any = this._renderer2.createElement( 'script' );
			s.src = '//assets.freshdesk.com/widget/freshwidget.js';
			s.async = true;
			s.type = 'text/javascript';
			s.onload = function () {
				(<any>window).FreshWidget.init( '', {
					'queryString': '&widgetType=popup&helpdesk_ticket[requester]=' + that.user.email,
					'utf8': '✓',
					'widgetType': 'popup',
					'buttonType': 'text',
					'buttonText': 'Support',
					'buttonColor': 'white',
					'buttonBg': '#006063',
					'alignment': '4',
					'offset': '235px',
					'formHeight': '500px',
					'url': 'lpgenerator.freshdesk.com',
					'loadOnEvent': 'immediate'
				} );
			};
			this._renderer2.appendChild( this._document.body, s );
		} catch (e) {}

	}


	ngOnInit() {
		this.init();
	}

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/core/freshdesk-chat/freshdesk-chat.component.ts